// Couche API du module Mbiyo Market (web) — mêmes endpoints que l'app native.
// ⚠ Ne JAMAIS modifier le backend depuis ce module : lecture + flux existants.
import apiService from '../apiService';

const q = (params) => {
  const s = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== '') s.set(k, v); });
  const str = s.toString();
  return str ? `?${str}` : '';
};

// Envoi multipart (photos d'ordonnance) — apiService.request impose du JSON.
async function uploadFiles(endpoint, files, field = 'photos') {
  const fd = new FormData();
  files.forEach(f => fd.append(field, f));
  const token = apiService.getToken('user');
  const res = await fetch(`${apiService.baseURL}${endpoint}`, {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: fd,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data.success) throw new Error(data.error || 'Envoi impossible');
  return data;
}

export const marketApi = {
  // ── Découverte ──
  suppliers: (params) => apiService.get(`/delivery/suppliers${q(params)}`),
  suppliersPopular: (params) => apiService.get(`/delivery/suppliers/popular${q(params)}`),
  suppliersNearby: (params) => apiService.get(`/delivery/suppliers/nearby${q(params)}`),
  suppliersNew: (params) => apiService.get(`/delivery/suppliers/new${q(params)}`),
  supplierDetail: (id) => apiService.get(`/delivery/suppliers/${id}`),
  promosActive: (supplierId) => apiService.get(`/delivery/promos/active${q({ supplier_id: supplierId })}`),
  supplierCategories: (id) => apiService.get(`/delivery/product-categories/supplier/${id}${q({ counts: 1 })}`),
  suggestions: (id, exclude) => apiService.get(`/delivery/suppliers/${id}/suggestions${q({ exclude, limit: 8 })}`),
  productsPopular: (params) => apiService.get(`/delivery/products/popular${q(params)}`),
  productsDeals: (params) => apiService.get(`/delivery/products/deals${q(params)}`),
  productsReorder: (params) => apiService.get(`/delivery/products/reorder${q(params)}`),
  productsSearch: (params) => apiService.get(`/delivery/products/search${q(params)}`),
  events: () => apiService.get('/events'),

  // ── Commande ──
  estimate: (body) => apiService.post('/delivery/orders/estimate', body),
  createOrder: (body) => apiService.post('/delivery/orders', body),
  myOrders: () => apiService.get('/delivery/orders/my'),
  orderDetail: (id) => apiService.get(`/delivery/orders/${id}`),
  cancelOrder: (id) => apiService.patch(`/delivery/orders/${id}/status`, { status: 'cancelled' }),

  // ── Paiement Mobile Money (flux pay-first, identique au natif) ──
  mmInitiate: (body) => apiService.post('/payments/serdipay/initiate', body),
  mmStatus: (paymentId) => apiService.get(`/payments/${paymentId}`),

  // ── Pharmacie : ordonnances & devis ──
  uploadPrescriptions: async (files) => (await uploadFiles('/pharmacy/prescriptions', files)).photos.map(p => p.photo_id),
  requestQuote: (body) => apiService.post('/pharmacy/quotes', body),
  myQuotes: () => apiService.get('/pharmacy/quotes/mine'),
  cancelQuote: (id) => apiService.patch(`/pharmacy/quotes/${id}/cancel`, {}),

  // ── Solde client ──
  myBalance: (userId) => apiService.get(`/balance/user/${userId}`),
};

export default marketApi;
